import { ForgotPasswordPage } from "@/features/auth/pages/AccountRecoveryPages";
import {
	PORTAL_PATH,
	isAccountRecoveryAvailable,
} from "@/layouts/portal/portalNavigation";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/vendor/lupa-kata-sandi")({
	beforeLoad: () => {
		if (!isAccountRecoveryAvailable) throw redirect({ to: PORTAL_PATH.Login });
	},
	component: ForgotPasswordPage,
});
